<template>
  <v-container fluid pa-0>
    <router-view />
  </v-container>
</template>

<script>
export default {};
</script>
